import styled from 'styled-components';
import { Box } from 'ui';

export const Message = styled(Box)`
  display: flex;
  justify-content: center;
  width: 100%;
`;
